module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cassiopeia/cas_dir-bbfe6d885e05dd9a20d562e8fa60f394.gif";